export default __webpack_public_path__ + "static/media/icons8-linkedin.9b484e0a.svg";